/* ============================================================
   FAMILY CAMPING — shared carousel initializer (no dependencies)
   Drives any .carousel[data-carousel] on the page: prev/next
   arrows, page-based pagination dots, active-dot sync, end-disabled
   arrow states, and a debounced resize rebuild.

   Works alongside the CSS layout switch: in grid mode the track
   does not overflow, so there is a single "page", arrows are
   disabled, and the nav is hidden by CSS — the JS stays inert.
   Re-runs on Shopify section load events so it works in the theme
   editor.
   ============================================================ */
(function () {
  function initCarousel(root) {
    if (!root || root.dataset.fcCarouselReady === '1') return;
    var track = root.querySelector('.carousel__track');
    if (!track) return;
    root.dataset.fcCarouselReady = '1';

    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var dots = root.querySelector('[data-dots]');

    function pageW() { return track.clientWidth || 1; }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - 4) / pageW())); }
    function current() { return Math.round(track.scrollLeft / pageW()); }
    function go(dir) { track.scrollTo({ left: (current() + dir) * pageW(), behavior: 'smooth' }); }

    function sync() {
      var c = current(), max = pages() - 1;
      if (prev) prev.disabled = c <= 0;
      if (next) next.disabled = c >= max;
      if (dots) {
        var ds = dots.children;
        for (var i = 0; i < ds.length; i++) ds[i].classList.toggle('is-active', i === c);
      }
    }

    function build() {
      if (dots) {
        var n = pages();
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'carousel__dot';
          b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          (function (idx) {
            b.addEventListener('click', function () {
              track.scrollTo({ left: idx * pageW(), behavior: 'smooth' });
            });
          })(i);
          dots.appendChild(b);
        }
      }
      sync();
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(build, 150);
    });

    build();
  }

  function initAll(scope) {
    var els = (scope || document).querySelectorAll('.carousel[data-carousel]');
    for (var i = 0; i < els.length; i++) initCarousel(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Shopify theme-editor support: re-init when a section is loaded/re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
